import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

// Locally hosted farmer/customer photos + video (reliable across all networks)
const IMG1 = "/images/farmer-workshop.jpeg";
const IMG2 = "/images/farmer-delivery.jpeg";
const VIDEO_POSTER = "/images/farmer-factory.jpeg";
const VIDEO_SRC = "/images/delivery-video.mp4";

export default function HappyCustomersSection() {
  return (
    <section data-testid="happy-customers-section" className="py-16 lg:py-20" style={{ backgroundColor: '#F9F8F4' }}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-12">
          <span className="text-xs font-semibold uppercase tracking-[0.2em]" style={{ color: '#D97706' }}>Real Customers</span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl mt-2" style={{ color: '#0A3F22' }}>Farmers Who Trust ARV</h2>
          <p className="text-sm mt-3 max-w-xl mx-auto" style={{ color: '#4A554A' }}>Real delivery moments — customers who visited our factory directly and took home their ARV machinery.</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.97 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }}
            data-customer-card
            className="md:col-span-1 rounded-2xl overflow-hidden relative group" style={{ aspectRatio: '3/4' }}
          >
            <img
              src={IMG1}
              alt="ARV Rotavator delivery to happy farmer Punjab"
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute bottom-0 left-0 right-0 p-4" style={{ background: 'linear-gradient(to top, rgba(10,63,34,0.85), transparent)' }}>
              <span className="text-xs font-semibold px-2 py-0.5 rounded-full" style={{ backgroundColor: '#D97706', color: '#fff' }}>Customer Delivery</span>
              <p className="text-white text-sm font-semibold mt-1">Rotavator handover — Punjab</p>
            </div>
          </motion.div>

          <div className="md:col-span-2 flex flex-col gap-4">
            <motion.div
              initial={{ opacity: 0, scale: 0.97 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
              data-customer-card
              className="rounded-2xl overflow-hidden relative group flex-1" style={{ minHeight: '200px' }}
            >
              <img
                src={IMG2}
                alt="Happy customer with new ARV machinery — Punjab"
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                style={{ maxHeight: '220px' }}
              />
              <div className="absolute bottom-0 left-0 right-0 p-4" style={{ background: 'linear-gradient(to top, rgba(10,63,34,0.85), transparent)' }}>
                <span className="text-xs font-semibold px-2 py-0.5 rounded-full" style={{ backgroundColor: '#D97706', color: '#fff' }}>Happy Customer</span>
                <p className="text-white text-sm font-semibold mt-1">Direct delivery — Punjab farmer</p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}
              className="rounded-2xl overflow-hidden bg-black" style={{ aspectRatio: '16/9' }}
            >
              <video
                poster={VIDEO_POSTER}
                controls
                preload="none"
                className="w-full h-full object-cover"
                style={{ display: 'block' }}
              >
                <source src={VIDEO_SRC} type="video/mp4" />
              </video>
            </motion.div>
          </div>
        </div>

        <div className="text-center mt-8">
          <Link
            to="/gallery"
            data-testid="view-all-deliveries-btn"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-heading font-semibold text-sm transition-all hover:opacity-80"
            style={{ backgroundColor: '#EAF2EC', color: '#0A3F22' }}
          >
            View All Customer Videos in Gallery
          </Link>
        </div>
      </div>
    </section>
  );
}
